// This file contains constants used in the environment service, which are meant to be shared cross-application.

import type { AgentSettingsApi } from '@env0/agent-settings-service/api';
import type { BlueprintApi } from '@env0/blueprint-service/api';

export const blueprintTypesThatSupportRemoteBackend: BlueprintApi.Blueprint['type'][] = [
  'terraform',
  'workflow',
  'opentofu'
];

export const internalTriggerNames = [
  'cd',
  'prPlan',
  'driftDetection',
  'ttl',
  'scheduled',
  'comment',
  'import',
  'driftRemediation'
] as const;

export const externalTriggerNames = ['user', 'terraform-cli', 'workflow'] as const;

// Share of the monthly run cap that counts as "approaching the limit". Used by the usage banner and by
// the email notification, which must agree on when a warning is due.
export const RUNS_USAGE_WARNING_THRESHOLD = 0.8;

export const unattendedTriggerNames = ['cd', 'scheduled', 'driftRemediation', 'ttl'] as const;
export type UnattendedTriggerName = (typeof unattendedTriggerNames)[number];

export const AUTOMATIC_DESTROY_TRIGGERS = ['ttl', 'scheduled'] as const;
export type AutomaticDestroyTrigger = (typeof AUTOMATIC_DESTROY_TRIGGERS)[number];

export const DeploymentLogStatuses = [
  'IN_PROGRESS',
  'WAITING_FOR_USER',
  'TIMEOUT',
  'FAILURE',
  'SUCCESS',
  'CANCELLED',
  'INTERNAL_FAILURE',
  'ABORTING',
  'ABORTED',
  'QUEUED',
  'SKIPPED',
  'NEVER_DEPLOYED'
] as const;

export const StoppedByTimeoutReasons = [
  'DEPLOYMENT_TIME_LIMIT_EXCEEDED',
  'AGENT_UNRESPONSIVE',
  'DEPLOYMENT_NOT_STARTED'
] as const;

export const SASS_AGENT_KEY: AgentSettingsApi.SassAgentKey = 'env0-Cloud-agent';

export const LAST_MODIFYING_DEPLOYMENT_FIELDS = [
  'startedAt',
  'finishedAt',
  'environmentId',
  'stateFileHash',
  'blueprintType',
  'variables',
  'providerVersions',
  'moduleVersions',
  'gitMetadata'
] as const;
export type LastModifyingDeploymentField = (typeof LAST_MODIFYING_DEPLOYMENT_FIELDS)[number];
